// @warp-css;

import { classNames } from "@chbphone55/classnames";
import { html, LitElement } from "lit";
import { property } from "lit/decorators.js";

import type { WarpStep } from "../step/step.js";
import { reset } from "../styles.js";
import { styles } from "./styles.js";

const ccSteps = {
	wrapper: "w-full",
	horizontal: "flex",
};

/**
 * Steps are used to show progress through a process or to guide users through a multi-step task.
 *
 * [Warp component reference](https://warp-ds.github.io/docs/components/steps/frameworks/elements)
 */
export class WarpStepIndicator extends LitElement {
	/**
	 * Display steps horizontally instead of vertically
	 */
	@property({ type: Boolean, reflect: true })
	horizontal = false;

	/**
	 * Align steps to the right (vertical layout only)
	 */
	@property({ type: Boolean, reflect: true })
	right = false;

	static styles = [reset, styles];

	updated() {
		this.updateStepsContext();
	}

	/**
	 * @internal
	 */
	updateStepsContext() {
		// Provide context to child step elements
		const steps = this.querySelectorAll<WarpStep>("w-step");
		steps.forEach((step, index) => {
			step.setContext({
				horizontal: this.horizontal,
				right: this.right,
				isLast: index === steps.length - 1,
				isFirst: index === 0,
			});
		});
	}

	render() {
		const classes = classNames([
			ccSteps.wrapper,
			this.horizontal && ccSteps.horizontal,
		]);

		return html`
			<div role="list" class=${classes}>
				<slot></slot>
			</div>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"w-step-indicator": WarpStepIndicator;
	}
}

if (!customElements.get("w-step-indicator")) {
	customElements.define("w-step-indicator", WarpStepIndicator);
}
